import {
	LIGHT_CARMINE_PINK,
	ORANGE_WEB,
} from "@/controls/shared/constants/colors";
import {} from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useElementStyles = makeStyles((theme) => ({
	gridWrapper: {
		"& .ag-cell.cell-below-min": {
			backgroundColor: ORANGE_WEB,
			fontWeight: "bold",
		},
		"& .ag-cell.cell-above-max": {
			backgroundColor: LIGHT_CARMINE_PINK,
			fontWeight: "bold",
		},
		"& .ag-header-cell-label": {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		},
		"& .delete-icon-container": {
			opacity: 0,
			transition: "opacity 0.1s ease-in-out",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			height: "100%",
		},
		"& .ag-row:hover .delete-icon-container": {
			opacity: 1,
		},
		"& .ag-row.ag-row-focus .delete-icon-container": {
			opacity: 1,
		},
		"& .ag-row.ag-row-selected .delete-icon-container": {
			opacity: 1,
		},
	},
}));
